<script setup lang="ts">
import { useAuthStore } from '@/stores/auth';
import ConfirmDialog from 'primevue/confirmdialog';
const store = useAuthStore();
store.fetchAuthUser();
</script>

<template>
  <div v-if="store.loaded">
    <router-view />
    <ConfirmDialog />
    <Toast />
  </div>

  <div v-else class="bg-white h-screen w-screen flex items-center justify-center">
    <div class="text-center">
      <i class="pi pi-spin pi-spinner text-4xl text-primary"></i>
      <p class="mt-4 text-gray-600">Loading...</p>
    </div>
  </div>
</template>

<style scoped></style>